import type { RouteObject } from 'react-router';
import { PageListeIndicateur } from './PageListeIndicateur';
import { PageTableauDeBord } from './PageTableauDeBord';
import { PageTerritoire } from '../territoire/PageTerritoire';

export const routesTableauDeBord: RouteObject[] = [
  { index: true, path: '/', element: <PageTableauDeBord /> },
  // Carte du territoire (entrée de navigation « Territoire », href /territoire) : déclarée ici,
  // à côté du Pilotage dont elle est la grande carte, sans toucher à Application.tsx.
  { path: '/territoire', element: <PageTerritoire /> },
  { path: '/tableau-de-bord/liste/:code', element: <PageListeIndicateur /> },
];
